module.exports = __webpack_public_path__ + "media/images/chart-1-d985e6109d34141591d2de1dcb62ce30.svg";